import {Badge} from "@/components/ui/badge";
import {resolveRowAmenityAccessRestricted} from "@/src/modules/households/lib/household-amenity-restriction";

import {getSafelistingCoverageStatus} from "../lib/has-future-date";
import {getSafelistingDisplayBadgeProps} from "../lib/safelisting-parent-status";
import type {Safelisting} from "../types";

type SafelistingCoverageStatusBadgeProps = {
  safelisting: Safelisting;
  timeZone: string;
  className?: string;
  /** When set, overrides row/nested household restriction flags (e.g. household show on resident home). */
  amenityRestricted?: boolean;
};

export function SafelistingCoverageStatusBadge({
  safelisting,
  timeZone,
  className,
  amenityRestricted: amenityRestrictedOverride,
}: SafelistingCoverageStatusBadgeProps) {
  const status = getSafelistingCoverageStatus(safelisting, timeZone);
  const amenityRestricted =
    amenityRestrictedOverride ?? resolveRowAmenityAccessRestricted(safelisting);
  const {label, variant} = getSafelistingDisplayBadgeProps(
    safelisting,
    status,
    amenityRestricted,
  );

  return (
    <Badge variant={variant} className={className}>
      {label}
    </Badge>
  );
}
